import { TranslationKeyMap } from './insight.i18n';

export enum PresentationView {
    GRID,
    TREND,
}

export const PresentationViewOpts: Array<{
    type: PresentationView;
    tlKey: string;
}> = [
    { type: PresentationView.GRID, tlKey: TranslationKeyMap._7136_GRID },
    { type: PresentationView.TREND, tlKey: TranslationKeyMap._989_TREND },
];
